// extracted by mini-css-extract-plugin
export default {"line":"EmployeesListItem_line__ZBPiW","fio":"EmployeesListItem_fio__AbKxs"};